module.exports = {
    GAMES_TO_SHOW: 4,
    // @TODO  заменить на актуальный текст
    SEARCH_QUERY_TEXT: 'ЧМ по футболу 2018',
    TEMPLATE_SCHEDULE_GET: 'TEMPLATE_SCHEDULE_GET',
    TEMPLATE_SCHEDULE_UPDATE: 'TEMPLATE_SCHEDULE_UPDATE',
};
